import { Routes, Route, Navigate } from 'react-router-dom';
import type { ReactNode } from 'react';
import { AuthProvider, useAuth } from './auth.js';
import type { Usuario } from './api.js';
import { Layout } from './Layout.js';
import { Login } from './pages/Login.js';
import { FichasLista } from './pages/FichasLista.js';
import { FichaDetalle } from './pages/FichaDetalle.js';
import { Usuarios } from './pages/Usuarios.js';
import { Configuracion } from './pages/Configuracion.js';
import { Perfil } from './pages/Perfil.js';

/** Protege una ruta: exige sesión y envuelve en el marco del panel.
 *  Con `rol`, exige además ese rol concreto (si no, redirige a fichas). */
function RequireAuth({ children, rol }: { children: ReactNode; rol?: Usuario['rol'] }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="loading">Cargando…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (rol && user.rol !== rol) return <Navigate to="/fichas" replace />;
  return <Layout>{children}</Layout>;
}

export function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/fichas"
          element={
            <RequireAuth>
              <FichasLista />
            </RequireAuth>
          }
        />
        <Route
          path="/fichas/:id"
          element={
            <RequireAuth>
              <FichaDetalle />
            </RequireAuth>
          }
        />
        <Route
          path="/usuarios"
          element={
            <RequireAuth rol="admin">
              <Usuarios />
            </RequireAuth>
          }
        />
        <Route
          path="/configuracion"
          element={
            <RequireAuth rol="admin">
              <Configuracion />
            </RequireAuth>
          }
        />
        <Route
          path="/perfil"
          element={
            <RequireAuth>
              <Perfil />
            </RequireAuth>
          }
        />
        <Route path="*" element={<Navigate to="/fichas" replace />} />
      </Routes>
    </AuthProvider>
  );
}
